import "antd/es/notification/style";
import _notification from "antd/es/notification";
import axios from 'axios';
import Cookies from 'js-cookie';
var axiosConfig = {
  baseURL: 'https://gateway.fxqifu.net/pangu',
  timeout: 60000
};
var httpClient = axios.create(axiosConfig);
// 登陆页面接口列表，不需要带token
var loginMap = [''];
httpClient.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'application/json;charset=UTF-8';
  if (loginMap.find(function (item) {
    return config.url.endsWith(item);
  })) {
    delete config.headers['authority_token'];
  } else {
    var tokenFrom = config['tokenFrom'];
    var token = '';
    switch (tokenFrom) {
      case 'cookie':
        token = Cookies.get('token');
        break;
      case 'localstorage':
        token = localStorage.getItem('token');
        break;
      default:
        token = Cookies.get('token') || localStorage.getItem('token');
    }
    config.headers['authority_token'] = token;
  }
  return config;
}, function (err) {
  _notification.error({
    message: '发送请求失败',
    // @ts-ignore
    description: err
  });
  return false;
});
httpClient.interceptors.response.use(function (res) {
  var status = res.status,
    data = res.data,
    statusText = res.statusText;
  return new Promise(function (resolve, reject) {
    if (status < 200 || status > 300) {
      _notification.error({
        message: "\u8BF7\u6C42\u9519\u8BEF: ".concat(status),
        description: statusText
      });
    } else if (!data.success) {
      if (data.code === '915003') {
        return reject(data);
      }
      if (data.code === '100003') {
        return reject(data);
      }
      _notification.error({
        message: '提示',
        description: data.message
      });
      return reject(data);
    } else {
      return resolve(data || true);
    }
    return reject();
  });
}, function () {
  _notification.error({
    message: '提示',
    description: '系统错误'
  });
  return false;
});
export default httpClient;